import { matchPath, useLocation } from 'react-router';

import {
  overviewPagePath,
  teamChainsPagePath,
  teamModelApisPagePath,
  teamModelsPagePath,
  teamTrainingPagePath,
} from '@/routes/constants';

import { useOrgUsersQuery } from './__generated__/queries.generated';
import { WorkspaceSections } from './types';

function useWorkspaceSection() {
  const location = useLocation();

  const match = (path: string) => matchPath(location.pathname, { path, exact: true });

  switch (true) {
    case !!match(teamModelApisPagePath):
      return WorkspaceSections.ModelAPIs;
    case !!match(teamModelsPagePath):
      return WorkspaceSections.Models;
    case !!match(teamChainsPagePath):
      return WorkspaceSections.Chains;
    case !!match(teamTrainingPagePath):
      return WorkspaceSections.Training;
    case !!match(overviewPagePath):
      return WorkspaceSections.Overview;
    default:
      return null;
  }
}

function useOrgUsers() {
  const { data, loading } = useOrgUsersQuery({
    fetchPolicy: 'cache-first',
  });

  return { users: data?.users, loading };
}

export { useWorkspaceSection, useOrgUsers };
